import { render, staticRenderFns } from "./CVTypeLanguageAbility.vue?vue&type=template&id=53c1b163"
import script from "./CVTypeLanguageAbility.vue?vue&type=script&lang=js"
export * from "./CVTypeLanguageAbility.vue?vue&type=script&lang=js"
import style0 from "./CVTypeLanguageAbility.vue?vue&type=style&index=0&id=53c1b163&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports